import { lazy } from 'react';

/**
 * Lazy-loaded SessionLocationMap (CU-86ajd3yt0). `maplibre-gl` is ~800KB; the
 * map only appears on the /sessions surface, so we split it out of the main
 * bundle rather than make every route (login, payment, chart…) pay for it.
 *
 * Both the lazy component AND the route-level prefetch reference the SAME
 * dynamic import below, so they dedupe: prefetching on /sessions mount warms
 * the exact chunk `React.lazy` later awaits — by the time a location card
 * mounts the chunk is typically already cached, so there is no user-visible
 * load state on this EMERGENCY-access surface. The fallback is a quiet styled
 * placeholder (not a spinner), and the map's actionable info (caption + the
 * "Open in maps" handoff) renders synchronously from flat data regardless.
 */
const importMap = () => import('./SessionLocationMap');

export const LazySessionLocationMap = lazy(importMap);

/**
 * Warm the map chunk ahead of need. Call on /sessions mount so the chunk is
 * in-flight/cached before any card requests the map. Safe to call repeatedly —
 * the browser/Vite dedupe the module fetch.
 */
export function prefetchSessionLocationMap(): void {
  void importMap();
}
